<template>
	<div class="container-modal form-modal">
		<div class="container-holder">
			<div class="header-modal">
				<div class="icon">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-6 h-6">
						<path
							stroke-width="1.5"
							vector-effect="non-scaling-stroke"
							stroke-linecap="round"
							stroke-linejoin="round"
							d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
						/>
					</svg>
				</div>
				<div class="title">Date facturare</div>
				<div class="description">
					Te rugăm să completezi aici datele de facturare. Le vom folosi pentru emiterea facturii fiscale.
				</div>
			</div>

			<div class="form-section">
				<div class="input-group-tbf w-mob-100">
					<label class="label-input">{{ $t("register.choose") }}</label>
					<div class="input-box">
						<multiselect
							class="select-tags-tbf"
							v-model="selectedTypePerson"
							:options="['company', 'individual']"
							:show-labels="false"
							:allow-empty="false"
							:searchable="false"
							@input="changeTypePerson"
						>
							<template slot="singleLabel" slot-scope="props">
								<span class="option__title">{{ $t("register_options." + props.option) }}</span>
							</template>
							<template slot="option" slot-scope="props">
								<span class="option__title">{{ $t("register_options." + props.option) }}</span>
							</template>
						</multiselect>
					</div>
				</div>

				<div
					class="input-group-tbf w-mob-100"
					v-bind:class="{ has_error: $v.user.complet_name.$error, complete: user.complet_name != '' && !$v.user.complet_name.$error }"
					v-if="selectedTypePerson == 'individual'"
				>
					<label class="label-input" for="complete_name">{{ $t("register.complet_name") }}</label>
					<div class="input-box">
						<input id="complete_name" type="text" autocomplete="off" class="input-text" v-model="user.complet_name" ref="first_input" />
					</div>
				</div>

				<div class="input-group-tbf w-mob-100" v-bind:class="{ has_error: $v.user.cnp.$error, complete: user.cnp != '' && !$v.user.cnp.$error }" v-if="selectedTypePerson == 'individual'">
					<label class="label-input" for="user_cnp">{{ $t("register.cnp") }}</label>
					<div class="input-box">
						<input id="user_cnp" autocomplete="off" type="text" class="input-text" v-model="user.cnp" />
					</div>
				</div>

				<div
					class="input-group-tbf w-mob-100"
					v-bind:class="{ has_error: $v.user.company_name.$error, complete: user.company_name != '' && !$v.user.company_name.$error }"
					v-if="selectedTypePerson == 'company'"
				>
					<label class="label-input" for="company_name">{{ $t("register.company") }}</label>
					<div class="input-box">
						<input id="company_name" autocomplete="off" type="text" class="input-text" v-model="user.company_name" />
					</div>
				</div>

				<div
					class="input-group-tbf w-mob-100"
					v-bind:class="{ has_error: $v.user.company_cui.$error, complete: user.company_cui != '' && !$v.user.company_cui.$error }"
					v-if="selectedTypePerson == 'company'"
				>
					<label class="label-input" for="company_cui">{{ $t("register.cui") }}</label>
					<div class="input-box">
						<input id="company_cui" type="text" autocomplete="off" class="input-text" v-model="user.company_cui" />
					</div>
					<div class="error-msg" v-if="invalidCui">{{ $t("validator.cui_invalid") }}</div>
				</div>

				<div
					class="input-group-tbf w-mob-100"
					v-bind:class="{ has_error: $v.user.bank_name.$error, complete: user.bank_name != '' && !$v.user.bank_name.$error }"
					v-if="selectedTypePerson == 'company'"
				>
					<label class="label-input" for="company_bank_name">{{ $t("register.bank_name") }}</label>
					<div class="input-box">
						<input id="company_bank_name" type="text" autocomplete="off" class="input-text" v-model="user.bank_name" />
					</div>
				</div>

				<!-- end date facturare -->
				<div class="input-group-tbf checkboxes-group">
					<label class="checkbox-tbf no-margin" v-bind:class="{ 'error-msg': $v.user.terms_and_conditions.$error }">
						<span class="text-checkbox" v-html="$t('register.terms', { terms_link: 'https://tbf.ro/termeni-si-conditii-generale' })"> </span>
						<input type="checkbox" value="1" v-model="user.terms_and_conditions" />
						<span class="checkmark"></span>
					</label>
				</div>
			</div>
			<div class="submit-form">
				<button class="button-submit" id="buttonSubmitStep21" @click="goNextStep">
					<div class="loader-spin" v-if="loadingSubmit"></div>
					<div class="text" v-else>{{ $t("register.button-action-2") }}</div>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import CloseIcon from "../Icons/Close";
import IconPlus from "../Icons/Plus";
import IconInfo from "../Icons/Info";
import IconFolder from "../Icons/Folder";
import IconArrow from "../Icons/Arrow";
import IconPeople from "../Icons/People";
import IconCircleCheck from "../Icons/CircleCheck";
import InformationIcon from "../Icons/Information";
import IconIndividual from "../Icons/Individual";
import IconOffice from "../Icons/Office";
import IconCnp from "../Icons/Cnp";
import IconBuilding from "../Icons/Building";
import IconCui from "../Icons/Cui";
import UserSettingsIcon from "../Icons/UserSettings";
import SettingsGoalIcon from "../Icons/SettingsGoal";
import IconObjectivesList from "../Icons/ObjectivesList";
import PasswordIcon from "../Icons/Password";
import IconCart from "../Icons/Cart";
import IconDots from "../Icons/Dots";
import { required, minLength, requiredIf, sameAs } from "vuelidate/lib/validators";

export default {
	data() {
		return {
			optionsCountry: [],
			value_country: "",
			selectedTypePerson: "company",
			invalidCui: "",
			activeTooltip: "",
			termsNotAccepted: "",
			cardErrors: {},
			errorCoupon: false,
			subModalShow: false,
			loadingSubmit: false,
			packageActive: {},
			packagesList: {},
		};
	},
	props: {
		user: Object,
	},
	components: {
		CloseIcon,
		IconPlus,
		IconInfo,
		IconFolder,
		IconArrow,
		IconPeople,
		IconCircleCheck,
		InformationIcon,
		IconIndividual,
		IconOffice,
		IconBuilding,
		IconCnp,
		IconCui,
		UserSettingsIcon,
		SettingsGoalIcon,
		IconObjectivesList,
		PasswordIcon,
		IconCart,
		IconDots,
	},
	validations: {
		value_country: { required },
		selectedTypePerson: { required },
		user: {
			terms_and_conditions: { sameAs: (val) => val === true },
			first_name: { required },
			last_name: { required },
			has_company: "",
			company_name: {
				requiredIf: requiredIf((user) => {
					return user.has_company == 1 || user.has_company === "";
				}),
			},
			// bank_name: {
			// 	requiredIf: requiredIf((user) => {
			// 		return user.has_company == 1 || user.has_company === "";
			// 	}),
			// },
			bank_name: {},
			company_cui: {
				requiredIf: requiredIf((user) => {
					return user.has_company == 1 || user.has_company === "";
				}),
			},
			complet_name: {
				requiredIf: requiredIf((user) => {
					return user.has_company == 0;
				}),
			},
			cnp: {
				requiredIf: requiredIf((user) => {
					return user.has_company == 0;
				}),
				minLength: minLength(13),
			},
		},
	},
	watch: {},
	async mounted() {
		this.user.complet_name = this.user.last_name + " " + this.user.first_name;
		await this.getPackages();
		await this.getCountries();
	},
	methods: {
		async getPackages() {
			await axios.get("packages").then(({ data }) => {
				this.packagesList = data.reverse();
				if (this.$route.query.reducere) {
					this.packageActive = this.packagesList.find((el) => el.token == this.$route.query.reducere);
					if (this.packageActive) {
						this.user.packageActive = this.packageActive;
					} else {
						this.packageActive = this.packagesList.find((el) => el.token == "33e71c8436036b299a0dabfb534a28058");
						this.user.packageActive = this.packageActive;
					}
				} else {
					// default merge pe Curs de management pret intreg
					this.packageActive = this.packagesList.find((el) => el.token == "33e71c8436036b299a0dabfb534a28058");
					this.user.packageActive = this.packageActive;
				}
				this.packagesList = [this.packageActive];
			});
		},
		async getCountries() {
			await axios.get("/countries").then(({ data }) => {
				this.optionsCountry = data.data;
				this.value_country = this.optionsCountry.find((el) => el.iso == this.user.language.toUpperCase());
				this.user.country = this.value_country;
			});
		},
		goNextStep() {
			var btnSubmit = document.getElementById("buttonSubmitStep21");
			btnSubmit.disabled = true;
			this.loadingSubmit = true;

			this.$v.$touch();
			if (this.$v.$invalid) {
				btnSubmit.disabled = false;
				this.loadingSubmit = false;
			} else {
				this.submitRegister();
			}
		},
		submitRegister() {
			var btnSubmit = document.getElementById("buttonSubmitStep21");
			this.invalidCui = false;
			var app = this;

			var formData = {
				first_name: this.user.first_name,
				last_name: this.user.last_name,
				password: this.user.password,
				phone: this.user.phone,
				email: this.user.email,
				language: this.user.language,
				country_id: this.user.country.id,
				has_company: this.user.has_company,
				agree_with_terms: this.user.terms_and_conditions,
				package_token: this.user.packageActive.token,
				referral_uuid: this.user.referral_uuid,
				coupon: this.user.coupon,
			};
			if (this.user.has_company) {
				formData.company_name = this.user.company_name;
				formData.cui = this.user.company_cui;
				formData.bank_name = this.user.bank_name;
			} else {
				formData.name = this.user.complet_name;
				formData.cnp = this.user.cnp;
			}

			this.$auth.register({
				data: formData,
				dataType: "json",
				success: function() {
					this.$auth.login({
						data: {
							email: app.user.email,
							password: "testing123",
						},
						success: function() {
							setTimeout(() => {
								app.$router.replace("/payment?token=" + this.$auth.user().package.token);
								app.$emit("next_step", { user: app.user, next_step: 3 });
							}, 500);
						},
						error: function(res) {
							btnSubmit.disabled = false;
							this.loadingSubmit = false;
						},
						rememberMe: true,
						fetchUser: true,
					});
				},
				error: function(res) {
					this.invalidCui = true;
					btnSubmit.disabled = false;
					this.loadingSubmit = false;
				},
				rememberMe: true,
				fetchUser: true,
			});
		},

		selectCountry(value, id) {
			this.user.country = value;
		},
		closeModal() {
			this.$router.push("/login");
		},
		closeModalCoupon() {
			this.subModalShow = false;
		},
		changeTypePerson(type) {
			this.selectedTypePerson = type;
			if (this.selectedTypePerson == "company") {
				this.user.has_company = 1;
			} else {
				this.user.has_company = 0;
			}
		},
		displayModal() {
			this.subModalShow = true;
		},
	},
};
</script>
